const state = {
  communications: [],
  generalMaster: {},
  planLists: [],
  scheduleSectionData: {},
  createScheduleForm: {
    scheduleNo: undefined,
    general: {},
    planned: {},
    email: [],
    SubmitSchedule: {},
  },
  payoutCommunicationDropDownData: {},
  partialPayoutDateItemData: [],
  previousPayoutCommunicationsForProgramData: [],
  storePreviousPastCommu: false,
  payoutCommInProgressAsync: "",
};


export default state;
